import * as React from 'react';
export const SYSvg = React.forwardRef(function SYSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        fillRule: 'nonzero',
        d: 'M0 6h16v4H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        d: 'M6 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm4 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z',
        opacity: 0.9,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M15 10V6h1v4h-1ZM0 6h1v4H0V6Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M16 4v2H0V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        fillRule: 'nonzero',
        d: 'M0 12v-2h16v2a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2Z',
      }),
    ),
  );
});
SYSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var SY = {
  category: 'flag',
  colorable: false,
  name: 'SY',
  svg: SYSvg,
};
